import gsap from 'gsap';

import BezierEasing from 'bezier-easing';

import Component from '../base/component';
import { qs, qsa, NodeList, toggleClass } from '../base/dom-utils';

const bureauEase = new BezierEasing(0.77, 0, 0.175, 1);

class BureauCollection extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.$els.locations = new NodeList(this.options.locations, this.$el);
        this.$els.results = qsa(this.options.results, this.$el).reverse();
    }

    beforeInit() {

        this.delegate('click', this.options.locations, (e) => {
            e.preventDefault;

            if (!this.getState('isAnimating')) {
                this.setState('isAnimating', true);

                const clickedEl = e.target.parentNode;
                this.setState('currentItem', parseInt(this.$els.locations.indexOf(clickedEl), 10));
            }
        });

        this.on('change:currentItem', (newItem, oldItem) => {
            this.toggleLocations(newItem);
            this.toggleResults(newItem, oldItem);
        });
    }

    toggleLocations(newItem) {
        this.$els.locations.removeClass(this.options.active);

        const currEl = this.$els.locations.eq(newItem);
        toggleClass(currEl, this.options.active, true);
    }

    toggleResults(newItem, oldItem) {

        this.$els.results.forEach((result, i) => {
            const allItems = new NodeList(this.options.item, result);
            const oldEl = allItems.eq(oldItem);
            const currEl = allItems.eq(newItem);

            const tl = new TimelineMax();

            if (oldEl) {

                const frame = qs(this.options.frame, oldEl);

                tl.to(frame.children, 0.6, {
                    yPercent: -100,
                    ease: new Ease(bureauEase)
                });
            }

            if (currEl) {

                const frame = qs(this.options.frame, currEl);

                tl.to(frame.children, 0.4, {
                    delay: i * 0.1,
                    y: 0,
                    onComplete: () => {

                        if (oldEl) {

                            toggleClass(oldEl, this.options.active, false);

                            const oldFrame = qs(this.options.frame, oldEl);

                            tl.set(oldFrame.children, {
                                clearProps: 'all'
                            });
                        }

                        toggleClass(currEl, this.options.active, true);

                        this.setState('isAnimating', false);
                    }
                });

            }

        });
    }

    getInitialState() {
        return {
            currentItem: 0,
            isAnimating: false
        };
    }

    getDefaultOptions() {
        return {
            locations: '.c-bureau__location',
            results: '.c-bureau__result',
            item: '.c-bureau__item',
            frame: '.o-text__frame',
            active: 'is-active'
        };
    }

}

export default BureauCollection;


/** WEBPACK FOOTER **
 ** ./components/bureau-collection.js
 **/